"use strict";

exports.__esModule = true;
exports.LogoutMenuItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _AuthContext = require("../../Auth/AuthContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var LogoutButton = (0, _styledComponents["default"])(_core.MenuItem).attrs({
  className: "logout-button"
}).withConfig({
  displayName: "LogoutMenuItem__LogoutButton",
  componentId: "sc-16v0jrr-0"
})(["&.", "{color:#ff7373;}&.", ":hover{color:#ffffff;background:#db3737;}"], _core.Classes.MENU_ITEM, _core.Classes.MENU_ITEM);
var LogoutMenuItem = exports.LogoutMenuItem = function LogoutMenuItem() {
  var _useContext = (0, _react.useContext)(_Translator.TranslatorContext),
    translate = _useContext.translate;
  //$FlowFixMe
  var _useContext2 = (0, _react.useContext)(_AuthContext.AuthContext),
    logout = _useContext2.logout;
  return /*#__PURE__*/_react["default"].createElement(LogoutButton, {
    text: translate("SettingsMenu.Logout", "Logout"),
    onClick: logout
  });
};